(() => {
  const clampQuantity = (input, delta) => {
    const min = Number(input.min || 0);
    const max = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
    const next = Math.min(max, Math.max(min, Number(input.value || min) + delta));
    input.value = String(next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  document.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('[data-eph-quantity]');
    if (quantityButton) {
      const input = quantityButton.closest('.eph-quantity')?.querySelector('input[type="number"]');
      if (input) clampQuantity(input, quantityButton.dataset.ephQuantity === 'plus' ? 1 : -1);
      return;
    }

    const mediaLink = event.target.closest('[data-eph-media-target]');
    if (mediaLink) {
      const gallery = mediaLink.closest('.eph-gallery');
      const target = document.getElementById(mediaLink.dataset.ephMediaTarget);
      if (!gallery || !target) return;
      event.preventDefault();
      gallery.querySelectorAll('[data-eph-gallery-media]').forEach((media) => {
        media.hidden = media !== target;
      });
      gallery.querySelectorAll('[data-eph-media-target]').forEach((link) => {
        link.toggleAttribute('aria-current', link === mediaLink);
      });
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.eph-product-form, .eph-quick-add-form, #EphCartForm');
    if (!form) return;
    form.setAttribute('aria-busy', 'true');

    // Shopify uses the clicked cart submit button's name to distinguish an
    // update from checkout. Disabling that button during the submit event
    // removes its name from the request and turns Checkout into an update.
    if (form.id === 'EphCartForm') return;

    form.querySelectorAll('button[type="submit"]').forEach((button) => {
      button.disabled = true;
    });
  });
})();
